import { selectItem } from 'store/property/propertyActions';
import { createSelectItemEvent } from '../eventCreators';
import { createSelectItemEventPayload } from '../dataHelpers/createSelectItemEventPayload';

const emitSelectItem = ({ payload }) => {
  // map results list does not show strikethrough pricing
  const offer = JSON.parse(JSON.stringify(payload.offer));
  if (payload.type === 'map' && offer?.charges?.strikethrough) {
    delete offer.charges.strikethrough;
  }

  const selectItemEvent = createSelectItemEvent(
    createSelectItemEventPayload({
      availableProperties: payload.availableProperties,
      availableRooms: payload.availableRooms,
      category: payload.category,
      ctaMessage: payload.ctaMessage,
      ctaMessageCategory: payload.ctaMessageCategory,
      isRebooked: payload.isRebooked,
      listName: payload.listName,
      location: payload.location,
      offer,
      pageType: payload.pageType,
      payWith: payload.payWith,
      pointsConversion: payload.pointsConversion,
      property: payload.property,
      query: payload.query,
      recommendedProperty: payload.recommendedProperty || false,
      roomType: payload.roomType,
      type: payload.type,
    }),
  );

  return selectItemEvent;
};

// eslint-disable-next-line
// @ts-ignore
export default { [selectItem]: emitSelectItem };
